import { cn } from "@/lib/utils";
import { BGPattern } from "@/components/ui/bg-pattern";

type MagicBgPatternProps = React.ComponentProps<"div"> & {
  size?: number;
  fill?: string;
};

const MagicBgPattern = ({ size = 60, fill = "rgba(120,103,238,0.32)", className, ...props }: MagicBgPatternProps) => (
  <div className={cn("pointer-events-none absolute inset-0 -z-10 overflow-hidden", className)} {...props}>
    <div className="absolute inset-0 bg-gradient-to-br from-[#080414]/80 via-transparent to-[#010106]/85 blur-[130px]" />
    <BGPattern variant="grid" mask="fade-edges" size={size} fill={fill} className="opacity-90 mix-blend-screen" />
    <BGPattern variant="grid" mask="fade-edges" size={size * 2} fill="rgba(3,5,18,0.9)" className="opacity-25" />
    <div className="absolute inset-x-0 top-0 h-56 bg-gradient-to-b from-black via-transparent to-transparent opacity-70" />
    <div className="absolute inset-x-0 bottom-0 h-48 bg-gradient-to-t from-black/40 to-transparent" />
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(5,3,20,0.85),transparent_60%)]" />
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(5,3,20,0.8),transparent_60%)]" />
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,rgba(0,0,0,0.75),transparent_60%)]" />
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_right,rgba(0,0,0,0.75),transparent_60%)]" />
  </div>
);

MagicBgPattern.displayName = "MagicBgPattern";

export { MagicBgPattern };
